import React from 'react'
import { Link } from 'react-router-dom'

const Navbar = () => (
  <nav>
    <div className="container">
      <h1>Rutec Engineering</h1>
      <ul>
        <li><Link to="/">Inicio</Link></li>
        <li><Link to="/sobre">Quiénes somos</Link></li>
        <li><Link to="/trabajos">Trabajos</Link></li>
        <li><Link to="/contacto">Contacto</Link></li>
      </ul>
    </div>
  </nav>
)

export default Navbar